import { Dialog, DialogContent, DialogDescription } from '@/components/ui/dialog';
import { DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Lock } from 'lucide-react';
import type { ErrorDialogsProps } from './index';

/**
 * A write was refused with 402: the account has no active plan, so it is
 * read-only. Not the Forbidden dialog, which says the person is not allowed and
 * sends them to their manager; here the way forward is a plan, so it links to
 * the billing settings. The server's own message is the body, so the wording
 * lives in one place (billing-write-guard.ts).
 */
export const ReadOnlyDialog = ({ apiError, setApiError }: ErrorDialogsProps) => {
  const onOpenChange = (value: boolean) => {
    if (!value) setApiError(null);
  };

  return (
    <Dialog open={true} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-4">
            <Lock className="h-8 w-8 text-amber-500" />
            Your account is read-only
          </DialogTitle>
          <DialogDescription className="flex flex-col gap-4 py-5">
            {apiError?.message || 'This account has no active plan, so changes are paused.'}
          </DialogDescription>
        </DialogHeader>
        <p>Your data is still here to view. Nothing is lost.</p>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
          <Button asChild>
            <a href="/settings/billing">Go to billing</a>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
